import React from 'react';
import { Link } from '../../../env';
const Download = ({ handleMain }) => {
    const Downloads = [
        {
            title: 'Tuning and Remap Software',
            description: `Optimize your vehicle's performance with our advanced Tuning and Remap Software, designed to enhance power and efficiency seamlessly`,
            link: 'https://c695764.parspack.net/c695764/IRSystem_Software/downloads/IRSystemRemapV6033.exe',
            version: 'V6.0.33',
            img: `${Link}assets/JPEG/Download_Remap_Img.jpg`
        },
        {
            title: 'Advanced ECU Repair Software',
            description: `Streamline and enhance your ECU diagnostics and repairs with our sophisticated ECU Repair Software, tailored for precision and efficiency`,
            link: 'https://c695764.parspack.net/c695764/IRSystem_Software/downloads/IRSystemEcu_V320.exe',
            version: '',
            img: `${Link}assets/JPEG/ecufixing.webp`
        },
        {
            title: 'Remote Software : ALPEMIX',
            description: 'Access seamless support with our use of industry-standard remote software, ensuring quick and reliable assistance for our customers.',
            link: 'https://c695764.parspack.net/c695764/IRSystem_Software/downloads/ALPEMIX.exe',
            version: '',
            img: `${Link}/assets/Icons/gear.png`
        },
        {
            title: 'Remote Software : AnyDesk',
            description: 'Access seamless support with our use of industry-standard remote software, ensuring quick and reliable assistance for our customers.',
            link: 'https://c695764.parspack.net/c695764/IRSystem_Software/downloads/AnyDesk.exe',
            version: '',
            img: `${Link}/assets/Icons/gear.png`
        },
        {
            title: 'Video Driver',
            description: `This software expertly manages and facilitates the rendering of videos`,
            link: 'https://c695764.parspack.net/c695764/IRSystem_Software/downloads/Xvid-1.3.5-20171208.exe',
            version: '',
            img: `${Link}/assets/Icons/gear.png`
        }
    ]
    return (
        <div className='w-full relative min-h-screen bg-[#283747]'>
            <div className='w-full absolute top-0 left-0 z-20'>
                <div className='w-full sticky top-0 left-0 z-20 flex justify-end py-5 px-6'>
                    <a href='/'><img src={`${Link}assets/Icons/return.png`} className='w-[50px] rounded-full p-2 border-2 border-white bg-[#1a5276]' onClick={handleMain} /></a>
                </div>
            </div>
            <div className='w-full px-5 absolute top-0 left-0 min-h-full flex justify-center items-center z-10'>
                <div className='w-full'>
                    {
                        Downloads.map((item, index) => {
                            return (<>
                                <div key={index} className='w-full flex my-5 h-[70px] border-[1px] rounded-xl'>
                                    <div className='w-[85%] h-full flex text-sm items-center text-white px-5 poppins-regular'>
                                        <a href={item.link}>{item.title}</a>
                                    </div>
                                    <div className='w-[15%] h-full flex items-center'>
                                        <img src={`${Link}assets/Mobile/Downloads.png`} className='w-[30px]' />
                                    </div>
                                </div>
                            </>)
                        })
                    }
                </div>
            </div>
        </div>
    );
}

export default Download;
